<template>
  <div id="unsupportedBody">
    <!-- loading效果 -->
    <div v-show="showLoading" id="loadingContainer" class="loading-container">
      <div class="loader" />
    </div>

    <div v-show="!showLoading" id="unsupportedContent" class="contact-container">
      <div id="unsupportedContainer">
        <div id="unsupportedImage" class="unsupported-img">
          <img v-show="!showError" id="unsupportedImg" src="@/assets/images/unsupported/unsupported.png" />
          <img v-show="showError" id="errorImg" src="@/assets/images/unsupported/error.png" />
          <div v-show="!showError" id="tipErrorMsg" class="tip-msg">{{ tipErrorMsg }}</div>
          <div v-show="showError" id="invalidTip" class="tip-msg">{{ invalidTip }}</div>
          <!-- 手机端跳转App -->
          <a ref="sandstalkMobileStart" href="" target="_blank" style="display: none" />
        </div>
        <div v-show="!showError" id="errorHideButton" class="button">
          <div class="unsupported-button-distance">
            <div id="userExperience" class="unsupported-button-text">{{ userExperience }}</div>
            <div id="scanCode" class="unsupported-button-text">{{ scanCode }}</div>
          </div>
          <div class="button-text" @click="download">
            <span id="downloadApp">{{ downloadApp }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const router = useRouter()

// 响应式数据
const showLoading = ref(true)
const showError = ref(false)
const tipErrorMsg = ref('暂不支持浏览器网页端参与')
const userExperience = ref('为提供更佳的用户体验')
const scanCode = ref('请使用"沙滩说"APP进行扫码参与')
const downloadApp = ref('前往下载APP')
const invalidTip = ref('该链接不存在')

// URL参数
const jumpType = ref(route.query.jumpType as string)
const jumpId = ref(route.query.jumpId as string)
const errmsg = ref(route.query.errmsg as string)
const qrcode = ref(route.query.qrcode as string)
const isShortUrl = ref(route.query.isShortUrl as string)
const tenantId = ref(route.query?.tenantId as string)
const clientType = ref(route.query.clientType as string)
localStorage.setItem('cachedTenantId', tenantId.value)

// API基础URL配置
const getApiBaseUrl = () => {
  const { hostname } = window.location
  if (hostname === 'edu.sandstalk.com') {
    return 'https://saas-sandsgw.sandstalk.com'
  } else if (hostname === 'test-sands.jms.com') {
    return 'https://sands-saas-test-sandsgw.jnt-express.com.cn'
    // return 'http://test-sandsgw.jms.com'
  } else if (hostname === 'sands-test-edu.jnt-express.com.cn') {
    return 'https://sands-saas-test-sandsgw.jnt-express.com.cn'
    // return 'http://test-sandsgw.jms.com'
  } else if (hostname.includes('demo')) {
    // return 'https://demo-saas-sandsgw.sandstalk.com'
    return 'https://demo-sandsgw.sandstalk.com'
  } else {
    // return 'https://demo-saas-sandsgw.sandstalk.com'
    return 'https://demo-sandsgw.sandstalk.com'
  }
}

// 获取多语言文本
const fetchI18nTexts = async () => {
  if (!navigator.language) return

  const apiBaseUrl = getApiBaseUrl()

  if (navigator.language) {
    try {
      const response = await axios.get(`${apiBaseUrl}/sands-system/api/v1/translate/i18ns`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'accept-language': navigator.language
        }
      })

      if (response.data.code === 1) {
        if (Object.keys(response.data.data).length === 0) {
          /* 多语言不存在 */
          tipErrorMsg.value = '暂不支持浏览器网页端参与'
          userExperience.value = '为提供更佳的用户体验'
          scanCode.value = '请使用"沙滩说"APP进行扫码参与'
          downloadApp.value = '前往下载APP'
          if (errmsg.value) {
            invalidTip.value = '该链接不存在'
          }
        } else {
          /* 多语言存在，使用接口返回的文本 */
          // eslint-disable-next-line dot-notation
          tipErrorMsg.value = response.data.data['app_tipErrorMsg'] || tipErrorMsg.value
          // eslint-disable-next-line dot-notation
          userExperience.value = response.data.data['app_userExperience_tip'] || userExperience.value
          // eslint-disable-next-line dot-notation
          scanCode.value = response.data.data['app_share_downloadTip'] || scanCode.value
          // eslint-disable-next-line dot-notation
          downloadApp.value = response.data.data['app_share_downloadApp'] || downloadApp.value
          if (errmsg.value) {
            // eslint-disable-next-line dot-notation
            invalidTip.value = response.data.data['app_share_invalidTip'] || invalidTip.value
          }
        }
      } else {
        /* 多语言接口报错，使用默认文本 */
        tipErrorMsg.value = '暂不支持浏览器网页端参与'
        userExperience.value = '为提供更佳的用户体验'
        scanCode.value = '请使用"沙滩说"APP进行扫码参与'
        downloadApp.value = '前往下载APP'
        if (errmsg.value) {
          invalidTip.value = '该链接不存在'
        }
      }
    } catch (error) {
      console.log(error, 'error')
      /* 请求失败，使用默认文本 */
      tipErrorMsg.value = '暂不支持浏览器网页端参与'
      userExperience.value = '为提供更佳的用户体验'
      scanCode.value = '请使用"沙滩说"APP进行扫码参与'
      downloadApp.value = '前往下载APP'

      if (errmsg.value) {
        invalidTip.value = '该链接不存在'
      }
    }
  }
}

// 设备检测和页面适配
const setupDeviceAdaptation = () => {
  const downloadWidth = window.innerWidth
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile = /iphone|ipad|ipod|android|mobile|phone|blackberry|windows phone/.test(userAgent)

  const unsupportedContainer = document.getElementById('unsupportedContainer')
  const unsupportedImage = document.getElementById('unsupportedImage')

  if (!isMobile) {
    // PC
    if (unsupportedContainer) {
      unsupportedContainer.style.minHeight = '420px'
    }
    if (unsupportedImage) {
      unsupportedImage.style.width = `${downloadWidth / 3}px`
      unsupportedImage.style.marginLeft = `${downloadWidth / 3}px`
    }
    handleLink(jumpType.value)
  } else {
    setTimeout(() => {
      // 检查是否在App内
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (window && (window as any).sandstalkapi && (window as any).sandstalkapi.handleRoute && !errmsg.value) {
        // 解析URL参数
        const url = window.location.href
        const queryString = url.substring(url.indexOf('?') + 1)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const params: Record<string, any> = {}

        queryString.split('&').forEach((pair) => {
          const keyValue = pair.split('=')
          const key = keyValue[0]
          const value = keyValue[1] || ''

          if (params[key]) {
            if (!Array.isArray(params[key])) {
              params[key] = [params[key]]
            }
            params[key].push(value)
          } else {
            params[key] = value
          }
        })

        if (jumpType.value !== '100') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ;(window as any).sandstalkapi.handleRoute(params, { replace: true })
        } else {
          handleShortLink(jumpType.value)
        }
      } else {
        // 手机端跳转App
        if (errmsg.value !== null && jumpType.value !== '100' && isShortUrl.value !== 'true') {
          const link = document.querySelector('#sandstalkMoblieStart') as HTMLAnchorElement
          if (link) {
            link.href = `sandstalk://route?jumpType=${jumpType.value}&jumpId=${jumpId.value}`
            link.click()
            window.location.href = link.href
          }
        }

        // Vue 短链接跳转
        if (isShortUrl.value === 'true') {
          handleShortLink(jumpType.value)
        }
      }
    }, 1000)
  }
}

// 处理链接跳转
const handleLink = (jumpType: string) => {
  let locationHref = ''
  const { hostname } = window.location

  if (hostname === 'www.sandstalk.com') {
    locationHref = 'https://edu.sandstalk.com'
  } else {
    locationHref = `https://${hostname}`
  }

  const jumpRoutes: Record<string, string> = {
    1: `${locationHref}/#/resource/courseDetails?id=${jumpId.value}&fileType=0&view=2`,
    2: `${locationHref}/#/resource/courseDetails?id=${jumpId.value}&fileType=1&view=2`,
    3: jumpId.value,
    4: `${locationHref}/#/trendsDetail?id=${jumpId.value}`,
    5: `${locationHref}/#/train/trainPage?taskId=${jumpId.value}`,
    6: `${locationHref}/#/exam?examId=${jumpId.value}`,
    7: `${locationHref}/#/survey?surveyId=${jumpId.value}`,
    8: `${locationHref}/#/feedBackCeo`,
    9: `${locationHref}/#/community/communityDetail?id=${jumpId.value}`,
    10: `${locationHref}/#/live/auth?id=${jumpId.value}`,
    11: `${locationHref}/#/studyTask`,
    12: `${locationHref}/#/myTrain`,
    13: `${locationHref}/#/resource/dailyLesson`,
    14: `${locationHref}/#/fieldTrends`,
    15: `${locationHref}/#/community/communityHome`,
    16: `${locationHref}/#/live/liveCenter`,
    18: `${locationHref}/#/resource/dailyLesson?classType=${jumpId.value}`,
    19: `${locationHref}/#/community/communityPlate?id=${jumpId.value}`,
    20: `${locationHref}/#/Check?id=${jumpId.value}`,
    23: `${locationHref}/#/signDetail?id=${jumpId.value}`,
    24: `${locationHref}/#/signAuto?id=${jumpId.value}`,
    25: `${locationHref}/#/practice?practiceId=${jumpId.value}`,
    26: `${locationHref}/#/lecturerDetail?lecturerId=${jumpId.value}`,
    28: `${locationHref}/#/faceDetail?faceId=${jumpId.value}`
  }

  if (jumpRoutes[jumpType]) {
    window.location.href = jumpRoutes[jumpType]
  }
}

// 处理短链接跳转
const handleShortLink = (jumpType: string) => {
  let shortLinkHref = ''
  const sandsTalkToken = localStorage.getItem('sandsTalkToken')
  const { hostname } = window.location

  if (hostname === 'www.sandstalk.com') {
    shortLinkHref = 'https://edu.sandstalk.com/web'
  } else {
    shortLinkHref = `https://${hostname}/web`
  }

  // 过滤调查问卷
  if (!sandsTalkToken && !(isShortUrl.value === 'true' && jumpType === '7' && clientType.value === 'web')) {
    const path = location.href.split('#')[1]
    const currentUrl = window.location.href
    if (currentUrl.includes('saas')) {
      router.replace('/login?redirect=' + encodeURIComponent(encodeURIComponent(path)))
    } else {
      router.replace('/enterpriseLogin?redirect=' + encodeURIComponent(encodeURIComponent(path)))
    }
    return
  }

  const shortRoutes: Record<string, string> = {
    1: `${shortLinkHref}/#/courseDetail?id=${jumpId.value}&courseId=&courseType=course&endingType=0&channel=0`,
    2: `${shortLinkHref}/#/courseDetail?id=${jumpId.value}&courseId=&courseType=courseWare&endingType=0&channel=0`,
    5: `${shortLinkHref}/#/trainingDetail?id=${jumpId.value}`,
    6: `${shortLinkHref}/#/examInfo?examId=${jumpId.value}`,
    7: `${shortLinkHref}/#/surveyInfo?investigationId=${jumpId.value}&status=1`,
    9: `${shortLinkHref}/#/comDetailLevel?id=${jumpId.value}`,
    12: `${shortLinkHref}/#/myTraining`,
    15: `${shortLinkHref}/#/community`,
    19: `${shortLinkHref}/#/communityDetail?id=${jumpId.value}`,
    20: `${shortLinkHref}/#/Check?id=${jumpId.value}`,
    21: `${shortLinkHref}/#/shopDetail?id=${jumpId.value}&source=appscan`,
    22: `${shortLinkHref}/#/shopIndex`,
    23: `${shortLinkHref}/#/applyDetail?id=${jumpId.value}`,
    24: `${shortLinkHref}/#/selfRegistrationDetail?id=${jumpId.value}`,
    25: `${shortLinkHref}/#/examPractiseInfo?practiseId=${jumpId.value}`,
    26: `${shortLinkHref}/#/lecturerDetail?lecturerId=${jumpId.value}`,
    28: `${shortLinkHref}/#/faceDetail?faceId=${jumpId.value}`,
    29: `${shortLinkHref}/#/merchantDetail?merchantDetailId=${jumpId.value}`,
    100: `${shortLinkHref}/#/noLoginSign?id=${jumpId.value}&jumpType=${jumpType}&qrcode=${qrcode.value}`
  }

  if (shortRoutes[jumpType]) {
    window.location.replace(shortRoutes[jumpType])
  }
}

// 下载按钮点击事件
const download = () => {
  window.location.replace('https://www.sandstalk.com/officialWebsite')
}

// 页面加载完成后的处理
const handlePageLoad = () => {
  setTimeout(() => {
    showLoading.value = false
    if (errmsg.value) {
      showError.value = true
    }
  }, 2000)
}

onMounted(() => {
  fetchI18nTexts()
  setupDeviceAdaptation()
  handlePageLoad()
})
</script>

<style scoped>
/* loading样式 */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #f39b00;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.contact-container {
  display: block;
}

.unsupported-img {
  margin: 60px 40px 0px;
  img {
    width: 100%;
  }
}

.unsupported-button-text {
  position: relative;
  text-align: center;
}

.button {
  position: fixed;
  bottom: 100px;
  width: 100%;
}

.unsupported-button-distance {
  margin-bottom: 12px;
}

.unsupported-button-text {
  width: 100%;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  line-height: 18px;
}

.button-text {
  background-color: #f39b00;
  padding: 19px 0px;
  width: 86%;
  left: 7%;
  position: fixed;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  border-radius: 30px;
  cursor: pointer;
}

.button-text span {
  display: block;
}

.tip-msg {
  position: relative;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #171921;
}

#unsupportedBody {
  display: flex;
  justify-content: center;
}
</style>
